import { Skeleton } from "@/components/ui/skeleton";

type RiskStrategyOptionsSkeletonProps = {
  count?: number;
};

/**
 * 风险策略列表骨架屏
 * 用于策略卡片加载中的占位展示，可在其他页面复用。
 */
export default function RiskStrategyOptionsSkeleton({
  count = 3,
}: RiskStrategyOptionsSkeletonProps) {
  return (
    <div className="space-y-2" aria-busy="true">
      {Array.from({ length: count }).map((_, idx) => (
        <div
          key={`risk-skeleton-${idx}`}
          className="w-full rounded-xl p-3"
          style={{
            background: "rgba(15,17,23,0.75)",
            border: "1.5px solid rgba(255,255,255,0.07)",
          }}
        >
          <div className="flex items-center gap-3">
            <Skeleton
              className="w-8 h-8 rounded-lg"
              style={{ background: "rgba(255,255,255,0.08)" }}
            />
            <div className="flex-1 space-y-2">
              <Skeleton
                className="h-3.5 w-24 rounded"
                style={{ background: "rgba(255,255,255,0.08)" }}
              />
              <Skeleton
                className="h-3 w-40 rounded"
                style={{ background: "rgba(255,255,255,0.06)" }}
              />
            </div>
            <Skeleton
              className="w-4 h-4 rounded-full"
              style={{
                background: "transparent",
                border: "2px solid rgba(255,255,255,0.10)",
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
